import { render, staticRenderFns } from "./RegistrationPlans.vue?vue&type=template&id=5b274a9c"
import script from "./RegistrationPlans.vue?vue&type=script&lang=js"
export * from "./RegistrationPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports